import React from "react";

import { Container, Content, Spacing, Text } from "../components";
import { Heading } from "../offering/heading";

export function NotFoundPage() {
  return (
    <Content>
      <Container padding={80} center>
        <Heading size="xl">404</Heading>
        <Spacing height={24} />
        <Text fontSize="lg" align="center">
          Page not found
        </Text>
      </Container>
    </Content>
  );
}
